import {
  createContext,
  Dispatch,
  FC,
  ReactNode,
  SetStateAction,
  useState,
} from 'react';

export interface GlobalContextProps {
  showingPromotionBanner: boolean;
  setShowingPromotionBanner: Dispatch<SetStateAction<boolean>>;
  userHasTripSaved: boolean;
  setUserHasTripSabed: Dispatch<SetStateAction<boolean>>;
  isDynamicUrl: boolean;
  setIsDynamicUrl: Dispatch<SetStateAction<boolean>>;
  dynamicUrl: Record<string, string>;
  setDynamicUrl: Dispatch<SetStateAction<any>>;
  isHeaderActive: boolean;
  setIsHeaderActive: Dispatch<SetStateAction<boolean>>;
  requestCallBackModal: boolean;
  setRequestCallBackModal: Dispatch<SetStateAction<boolean>>;
}

interface GlobalContextProviderProps {
  children: ReactNode;
}

const GlobalContext = createContext<GlobalContextProps>(
  {} as GlobalContextProps,
);

export const GlobalContextProvider: FC<GlobalContextProviderProps> = ({
  children,
}) => {
  const [showingPromotionBanner, setShowingPromotionBanner] = useState(false);
  const [userHasTripSaved, setUserHasTripSabed] = useState(false);
  const [isDynamicUrl, setIsDynamicUrl] = useState(false);
  const [dynamicUrl, setDynamicUrl] = useState({
    en: '',
    it: '',
    de: '',
    fr: '',
  });
  const [isHeaderActive, setIsHeaderActive] = useState(false);
  const [requestCallBackModal, setRequestCallBackModal] = useState(false);

  return (
    <GlobalContext.Provider
      value={{
        showingPromotionBanner,
        setShowingPromotionBanner,
        userHasTripSaved,
        setUserHasTripSabed,
        isDynamicUrl,
        setIsDynamicUrl,
        dynamicUrl,
        setDynamicUrl,
        isHeaderActive,
        setIsHeaderActive,
        requestCallBackModal,
        setRequestCallBackModal,
      }}>
      {children}
    </GlobalContext.Provider>
  );
};

export default GlobalContext;
